module.exports = __webpack_public_path__ + "img/582b145.jpg";